import client from "@/lib/api";

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

// Subscribe the current device. Must be called from a user gesture.
export async function enablePush() {
  if (!pushSupported()) throw new Error("Push not supported on this device");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("permission-" + permission);
  const { data } = await client.get("/push/vapid-public-key");
  if (!data.enabled || !data.publicKey) throw new Error("Push not configured on server");
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  await client.post("/push/subscribe", sub.toJSON());
  return sub;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return;
  try { await client.post("/push/unsubscribe", sub.toJSON()); } catch { /* ignore */ }
  await sub.unsubscribe();
}

// Re-register an existing subscription with the backend (e.g. after login) if already granted.
export async function syncPushIfGranted() {
  try {
    if (!pushSupported() || Notification.permission !== "granted") return;
    const sub = await currentSubscription();
    if (sub) await client.post("/push/subscribe", sub.toJSON());
  } catch { /* ignore */ }
}
